import { render, staticRenderFns } from "./company-address-card-edit.vue?vue&type=template&id=5a3b483b&scoped=true&"
import script from "./company-address-card-edit.vue?vue&type=script&lang=js&"
export * from "./company-address-card-edit.vue?vue&type=script&lang=js&"
import style0 from "./company-address-card-edit.vue?vue&type=style&index=0&id=5a3b483b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b483b",
  null
  
)

export default component.exports